import { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import { Logo } from "..";
import { PDLButton, PDLTypography } from "../../dna";
import PasswordInput from "../_passwordInput";
import "./index.scss";

interface ResetPasswordFormProps {
  onSubmit: (password: string) => void;
  loading?: boolean;
}

const ResetPasswordForm = ({
  onSubmit,
  loading = false,
}: ResetPasswordFormProps) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const validate = () => {
    const newErrors = {
      password: "",
      confirmPassword: "",
    };

    if (!password) {
      newErrors.password = "A senha é obrigatória";
    } else if (password.length < 6) {
      newErrors.password = "A senha deve possuir no mínimo 8 caracteres";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirme sua senha";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "As senhas não coincidem";
    }

    setErrors(newErrors);

    return !newErrors.password && !newErrors.confirmPassword;
  };

  const handleSubmit = useCallback(() => {
    if (!validate()) return;

    onSubmit(password);
  }, [password, confirmPassword, onSubmit]);

  return (
    <div className="pdl_component_forgot">
      <Logo variant="login" className="mb-5" />

      <Form className="d-grid gap-5">
        <div className="d-grid gap-1">
          <PDLTypography display size="md" weight="semibold">
            Redefinir senha
          </PDLTypography>

          <PDLTypography size="md">
            Informe sua nova senha e confirme-a para continuar.
          </PDLTypography>
        </div>

        <div className="d-grid gap-4">
          <div className="d-grid gap-3">
            <PasswordInput
              label="Senha"
              value={password}
              onChange={setPassword}
              placeholder="Mínimo 6 caracteres"
              error={errors.password}
              disabled={loading}
            />

            <PasswordInput
              label="Confirmar senha"
              value={confirmPassword}
              onChange={setConfirmPassword}
              placeholder="Repita sua senha"
              error={errors.confirmPassword}
              disabled={loading}
            />
          </div>

          <div className="d-grid gap-3 mt-4">
            <PDLButton
              type="button"
              variant="primary"
              onClick={handleSubmit}
              size="lg"
              disabled={loading}
            >
              {loading ? <span className="spinner"></span> : "Redefinir senha"}
            </PDLButton>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
